(function () {
  const STORAGE_KEY = 'hangard_wishlist';

  function getWishlist() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      return items.filter(function (item) {
        return item && typeof item === 'object' && item.id;
      });
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function updateWishlistCount() {
    const wishlist = getWishlist();
    const counters = document.querySelectorAll('[data-wishlist-count]');

    counters.forEach(function (counter) {
      counter.textContent = wishlist.length;
      counter.hidden = wishlist.length === 0;
    });
  }

  function updateButtons() {
  const wishlist = getWishlist();
  const buttons = document.querySelectorAll('.hangard-wishlist-btn, .hangard-product-wishlist');

  buttons.forEach(function (button) {
    const productId = button.dataset.productId;

    const isSaved = wishlist.some(function (item) {
      return item.id === productId;
    });

    button.classList.toggle('is-active', isSaved);

    button.setAttribute(
      'aria-label',
      isSaved ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'
    );
  });
}

  function renderWishlistPage() {
    const grid = document.getElementById('hangard-wishlist-grid');
    if (!grid) return;

    const empty = document.getElementById('hangard-wishlist-empty');
    const wishlist = getWishlist();

    grid.innerHTML = '';

    if (wishlist.length === 0) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    wishlist.forEach(function (item) {
      const card = document.createElement('div');
      card.className = 'hangard-wishlist-card';

     card.innerHTML = `
  <div class="hangard-wishlist-card__image-wrap">
    <a href="${item.url}" class="hangard-wishlist-card__image-link">
      <img src="${item.image}" alt="${item.title}">
    </a>

    <button class="hangard-remove-btn" data-remove-id="${item.id}" aria-label="Rimuovi dai preferiti">
      ×
    </button>
  </div>

  <div class="hangard-wishlist-card__info">
    <a href="${item.url}" class="hangard-wishlist-title">
      ${item.title}
    </a>

    <div class="hangard-wishlist-price">
      ${item.price}
    </div>

    <a href="${item.url}" class="hangard-wishlist-shop">
      Scopri prodotto
    </a>
  </div>
`;

      grid.appendChild(card);
    });
  }

  function toggleProduct(product) {
    let wishlist = getWishlist();

    const exists = wishlist.some(function (item) {
      return item.id === product.id;
    });

    if (exists) {
      wishlist = wishlist.filter(function (item) {
        return item.id !== product.id;
      });
    } else {
      wishlist.push(product);
    }

    saveWishlist(wishlist);
    updateButtons();
    updateWishlistCount();
    renderWishlistPage();
  }

  function removeProduct(productId) {
    let wishlist = getWishlist();

    wishlist = wishlist.filter(function (item) {
      return item.id !== productId;
    });

    saveWishlist(wishlist);
    updateButtons();
    updateWishlistCount();
    renderWishlistPage();
  }

  function initWishlistButtons() {
    document.addEventListener('click', function (event) {
      const button = event.target.closest('.hangard-wishlist-btn, .hangard-product-wishlist');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const product = {
        id: button.dataset.productId,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl,
        image: button.dataset.productImage,
        price: button.dataset.productPrice
      };

      if (!product.id) return;

      toggleProduct(product);
    });

    document.addEventListener('click', function (event) {
      const removeButton = event.target.closest('.hangard-remove-btn');

      if (!removeButton) return;

      event.preventDefault();

      const productId = removeButton.dataset.removeId;
      if (!productId) return;

      removeProduct(productId);
    });
  }

  window.HangardWishlist = {
    get: getWishlist,
    save: saveWishlist,
    updateCount: updateWishlistCount,
    updateButtons: updateButtons
  };

  document.addEventListener('DOMContentLoaded', function () {
    initWishlistButtons();
    updateButtons();
    updateWishlistCount();
    renderWishlistPage();
  });
})();